<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.SelectMainOrder')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="closeHandler()"
  >
    <div class="app-main-inner-row">
      <el-form
        label-width="80px"
        label-position="left"
        style="width: 100%"
      >

        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('Payment.mbl')">
              <el-input
                v-model="form.mawbNo"
                no="1"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.AirlineCompany')">
              <cargo-advance-select
                no="2"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true}"
                callback-method-type="value"
                :default-value="form.airCompany||''"
                :callback-params="{key:'airCompany'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('queryJob.bookingAgent')">
              <cargo-advance-select
                no="3"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true}"
                callback-method-type="value"
                :default-value="form.bookingAgent||''"
                :callback-params="{key:'bookingAgent'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_RegistrationDate')">
              <el-date-picker
                v-model="form.dateCreated"
                no="3"
                clearable
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                :start-placeholder="$t('CargoMsg.Cargo_DateFrom')"
                :end-placeholder="$t('CargoMsg.Cargo_CompleteDate')"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col style="text-align: left">
            <el-button
              no="4"
              style=""
              type="primary"
              @click="queryHandler(true)"
            >{{ $t('common.btn.query') }}
            </el-button>
            <el-button
              no="5"
              type="primary"
              @click="resetSearch"
            >{{ $t('CargoMsg.Cargo_Empty') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="app-main-inner-row row-grid"
      style="min-height:350px;padding-top: 10px"
    >
      <cargo-ag-grid
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :show-side-bar="false"
        :row-data="rowData"
        style="width:100%;height:350px;"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="queryHandler(false)"
      />
    </div>
    <div
      slot="footer"
      style="display: flex;justify-content: space-between"
    >
      <div
        v-show="type === 'input'"
        style="display: flex;flex: 1"
      >
        <span style="font-size: 12px;line-height: 28px">{{ $t('queryJob.ManualInput') }}</span>
        <el-input
          v-model="form.inputMAWBNo"
          no="6"
          style="width: 260px;margin-right: 5px"
        />
        <el-button
          no="7"
          type="primary"
          @click="useInputHandler"
        >{{ $t('WriteOff.use') }}</el-button>
      </div>
      <div
        v-show="type !== 'input' "
        style="display: flex;flex: 1;width: 260px"
      />
      <div style="display: flex">
        <el-button
          no="8"
          type="primary"
          @click="enterHandler"
        >{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button no="9" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryMAWBDetails } from '@/api/AirExport/mawbDetail'
import ColumnUtils from '@/utils/ColumnUtils'
import { getGridSelected } from '@/utils/agGrid'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getOfficeById } from '@/api/office'

const states = {
  new: 'new',
  input: 'input',
  attach: 'attach'
}

export default {
  name: 'SelectMAWBDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    type: { type: String, default: '' },
    operateType: { type: Number, default: -1 },
    carrierId: { type: Number, default: 0 }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      states: states,
      currentState: states.new,
      form: {
        airCompany: this.carrierId,
        bookingAgent: 0,
        mawbNo: '',
        inputMAWBNo: '',
        dateCreated: ''
      },
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rowData: [],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false
      },
      loading: false
    }
  },
  computed: {
    columnDefs() {
      if (this.states.attach === this.currentState) {
        return [
          { headerName: this.$t('Payment.mbl'), field: 'mawbNo', width: 200 },
          { headerName: this.$t('SeaExport.JobNo'), field: 'jobNo', width: 200 },
          {
            headerName: this.$t('CargoMsg.Cargo_BusinessModel'), field: 'operateType', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
            }
          },
          {
            headerName: this.$t('Payment.consignationCompany'), field: 'customerId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.AirlineCompany'), field: 'carrierId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RegistrationDate'),
            width: 150,
            field: 'dateCreated',
            cellRenderer: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }
        ]
      } else {
        return [
          { headerName: this.$t('Payment.mbl'), field: 'mawbNo', width: 200 },
          {
            headerName: this.$t('queryJob.bookingAgent'), field: 'bookingAgentId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.AirlineCompany'), field: 'carrierId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.status'), field: 'state', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.MAWBStateLabelFunction(params.value)
            }
          },
          { headerName: this.$t('SeaExport.AdditionalNotes'), field: 'remark', width: 200 },
          {
            headerName: this.$t('CargoMsg.Cargo_RegistrationDate'),
            width: 150,
            field: 'dateCreated',
            cellRenderer: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.innerVisible) {
        this.rowData = []
        this.searchConditions.total = 0
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    carrierId(newVal) {
      this.form.airCompany = newVal
    }
  },
  methods: {
    queryHandler(unPage = true) {
      let state = 0
      if (this.currentState === 'attach') {
        state = 1
      }
      const conditions = []
      if (this.form.bookingAgent && this.form.bookingAgent.length > 0) {
        const agentCondition = new AdvancedSearchOption(null, 'mawbDetial.AGENT_ID', this.form.bookingAgent, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(agentCondition.formatObj2Json())
      }
      if (this.form.airCompany && this.form.airCompany.length > 0) {
        const airCompanyCondition = new AdvancedSearchOption(null, 'mawb.CARRIER_ID', this.form.airCompany, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(airCompanyCondition.formatObj2Json())
      }
      if (this.form.mawbNo && this.form.mawbNo.length > 0) {
        const mawbNoCondition = new AdvancedSearchOption(null, 'mawbDetial.startMawbNo', this.form.mawbNo, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(mawbNoCondition.formatObj2Json())
      }
      if (this.form.dateCreated && this.form.dateCreated.length > 0) {
        const startTime = 'start=' + this.form.dateCreated[0] + ' 00:00:00'
        const endTime = 'end=' + this.form.dateCreated[1] + ' 23:59:59'
        const type = 'type=date,'
        const str = type + startTime + ',' + endTime
        const dateCreatedCondition = new AdvancedSearchOption(null, 'mawbDetial.DATE_CREATED', str, OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(dateCreatedCondition.formatObj2Json())
      }
      const stateCondition = new AdvancedSearchOption(null, 'mawbDetial.STATE', state, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(stateCondition.formatObj2Json())
      const body = {
        branchId: this.$store.getters.currentOfficeId,
        state: state,
        startMawbNo: this.form.mawbNo,
        bookingAgentId: this.form.bookingAgent,
        carrierId: this.form.airCompany,
        operateType: this.operateType,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        paging: true,
        conditions: conditions
      }
      this.loading = getLoading()
      queryMAWBDetails(body).then(res => {
        this.loading.close()
        this.rowData = []
        let total = 0
        if (res.data && res.data.list && res.data.list.length > 0) {
          for (const item of res.data.list) {
            if (item.jobNo && item.operateType && this.operateType !== -1 && item.operateType !== this.operateType) {
            } else {
              this.rowData.push(item)
            }
          }
          total = Number(res.data.total)
        }
        this.searchConditions.total = total
        if (unPage && this.searchConditions.total >= 0) {
          getOfficeById(this.$store.getters.currentOfficeId,).then(res => {
            if (res.data && res.data.remindMargin >= 0 && this.searchConditions.total < res.data.remindMargin) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CompanyTrackingNumLower', [res.data.remindMargin]))
            }
          })
        }
      })
    },
    getValueFromChild(obj) {
      this.form[obj.key] = obj.value
    },
    closeHandler() {
      this.innerVisible = false
    },
    enterHandler() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length !== 1) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
        return
      }
      this.$emit('enterEvent', chooseRows[0])
    },
    useInputHandler() {
      if (AirExportUtils.validateMAWBNum(this.form.inputMAWBNo)) {
        this.$emit('enterEvent', this.form.inputMAWBNo)
      } else {
        this.$message.warning(this.$t('queryJob.TheOrderNumberIsIllegal'))
        return
      }
    },
    resetSearch() {
      this.form.airCompany = ''
      this.form.bookingAgent = ''
      this.form.mawbNo = ''
      this.form.dateCreated = ''
    }
  }
}
</script>

<style lang="scss">
</style>
